import {NgProgressBrowserXhr, NgProgressModule} from 'ngx-progressbar';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ClearanceItemRouting,ClearanceItemComponent,ClearanceListComponent } from './index';
import { AppService } from '../app.service';
import { SharedModule } from '../shared/shared.module';
import { AssetManagerModule } from '../shared/asset-manager.module';
import { ClearanceItemService } from "./clearance-item.service";
import { ClearanceItemHistoryComponent } from './clearance-item-history.component';
import { CarouselComponent } from './carousel.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClearanceItemBulkModule } from './bulk-action/clearance-item-bulk.module';
import { ClearanceItemCommonModule } from './clearance-item-common.module';
import { ClearanceItemImageService } from './clearance-item-image.service';
import { NotesPanelComponent } from './notes-panel/notes-panel.component';
import { CINoteService } from './notes-panel/ci-note.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  imports: [
    SharedModule,
    ClearanceItemRouting,
    AssetManagerModule,
    BrowserAnimationsModule,
    ClearanceItemCommonModule,
    ClearanceItemBulkModule,
    MatTooltipModule,
    MatCardModule,
    MatIconModule,
    MatBadgeModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
  ],
  declarations: [
    ClearanceListComponent,
    ClearanceItemComponent,
    ClearanceItemHistoryComponent,
    NotesPanelComponent,
    ],
  providers: [
    ClearanceItemService,
    ClearanceItemImageService,
    CINoteService
  ],
})
export class ClearanceItemModule { }
